import { render } from "./ApplyToCollaborate.vue.js?vue&type=template&id=b32886ac!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ApplyToCollaborate.vue?vue&type=template&id=b32886ac"
import script from "./ApplyToCollaborate.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ApplyToCollaborate.vue?vue&type=script&lang=js"
export * from "./ApplyToCollaborate.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ApplyToCollaborate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/ApplyToCollaborate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b32886ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b32886ac', __exports__)) {
    api.reload('b32886ac', __exports__)
  }
  
  module.hot.accept("./ApplyToCollaborate.vue.js?vue&type=template&id=b32886ac!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ApplyToCollaborate.vue?vue&type=template&id=b32886ac", () => {
    api.rerender('b32886ac', render)
  })

}


export default __exports__